import React from "react";
import {
  Box,
  Flex,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  Image,
} from "@chakra-ui/react";
import CloseIconBlack from "../../../assets/images/product/closeIconBlack.svg";
import { formatDateDb, formatTimeDb } from "../../../utils/tools";
import "react-medium-image-zoom/dist/styles.css";

// Chấm công luồng mới: 1 dòng thông tin (cùng style các dòng sẵn có)
const InfoItem = ({ label, value }) => (
  <Flex
    flexWrap={"wrap"}
    display={"inline"}
    fontSize={"14px"}
    lineHeight={"17px"}
    fontWeight={400}
    color={"var(--color-label-employee)"}
    maxW={"252px"}
    w={"100%"}
  >
    {label}:
    <Text
      display={"inline"}
      ml={"12px"}
      fontSize={"14px"}
      lineHeight={"17px"}
      fontWeight={500}
      color={"var(--color-option-employee)"}
    >
      {value}
    </Text>
  </Flex>
);

const buildMinutesNote = (d) => {
  const parts = [];
  if (d?.checkinLateMinutes) parts.push(`Vào muộn ${d.checkinLateMinutes}p`);
  else if (d?.checkinEarlyMinutes) parts.push(`Vào sớm ${d.checkinEarlyMinutes}p`);
  if (d?.checkoutEarlyMinutes) parts.push(`Về sớm ${d.checkoutEarlyMinutes}p`);
  else if (d?.checkoutLateMinutes) parts.push(`Về muộn ${d.checkoutLateMinutes}p`);
  return parts.join(" · ") || "-";
};

const FormDetail = ({ isOpen, onClose, dataDetail }) => {
  const baseURL = process.env.REACT_APP_BACKEND_API || "http://localhost:3001";
  // Chấm công luồng mới: chỉ hiện khi bản ghi có dữ liệu chấm ra / phút / địa chỉ
  const hasV2Info =
    !!dataDetail?.checkoutTime ||
    dataDetail?.checkinLateMinutes !== undefined ||
    !!dataDetail?.checkinAddress;
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        // maxH={"80%"}
        // minH={"625px"}
        w={"100%"}
        maxW={"625px"}
        // overflowY={"auto"}
        // sx={{
        //   "&::-webkit-scrollbar": {
        //     width: "4px",
        //   },
        //   "&::-webkit-scrollbar-thumb": {
        //     width: "4px",
        //     borderRadius: "50px",
        //     background: "var(--color-background)",
        //   },
        //   "&::-moz-scrollbar": {
        //     width: "4px",
        //   },
        //   "&::-moz-scrollbar-thumb": {
        //     width: "4px",
        //     borderRadius: "50px",
        //     background: "var(--color-background)",
        //   },
        // }}
      >
        <form>
          <Flex flexDirection={"column"}>
            <Flex
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"10px"}
              padding={"25px 24px"}
              borderBottom={"1px solid var(--bg-line-employee)"}
            >
              <Text
                color="var(--color-header-employee)"
                fontSize={"18px"}
                fontWeight={"600"}
              >
                Chi tiết chấm công
              </Text>
              <Box cursor={"pointer"} onClick={onClose}>
                <Image src={CloseIconBlack} />
              </Box>
            </Flex>
            <Box flex={1} padding={"24px"}>
              <Text
                color={"var(--color-header-employee)"}
                fontSize={"16px"}
                fontWeight={"600"}
              >
                Tổng quan
              </Text>
              <Box
                background={"var(--fill-avatar)"}
                p={"16px 24px 16px 16px"}
                mt={"13px"}
                borderRadius={"8px"}
              >
                <Flex
                  justifyContent={"space-between"}
                  m={"24px 16px"}
                  gap={"27px"}
                >
                  <Flex
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                    maxW={"252px"}
                    w={"100%"}
                  >
                    Ngày tháng:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      {dataDetail?.checkinTime
                        ? formatDateDb(dataDetail?.checkinTime)
                        : "-"}
                    </Text>
                  </Flex>
                  <Flex
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                    maxW={"252px"}
                    w={"100%"}
                  >
                    Thời gian check in:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      {dataDetail?.checkinTime
                        ? formatTimeDb(dataDetail?.checkinTime)
                        : ""}
                    </Text>
                  </Flex>
                </Flex>
                {hasV2Info && (
                  <>
                    <Flex
                      justifyContent={"space-between"}
                      m={"24px 16px"}
                      gap={"27px"}
                    >
                      <InfoItem
                        label="Thời gian check out"
                        value={
                          dataDetail?.checkoutTime
                            ? `${formatTimeDb(dataDetail?.checkoutTime)}${
                                dataDetail?.isAutoCheckout ? " (tự động)" : ""
                              }`
                            : "Chưa chấm ra"
                        }
                      />
                      <InfoItem
                        label="Sớm / muộn"
                        value={buildMinutesNote(dataDetail)}
                      />
                    </Flex>
                    <Flex
                      justifyContent={"space-between"}
                      m={"24px 16px"}
                      gap={"27px"}
                    >
                      <InfoItem
                        label="Địa chỉ check in"
                        value={dataDetail?.checkinAddress || "-"}
                      />
                      <InfoItem
                        label="Địa chỉ check out"
                        value={dataDetail?.checkoutAddress || "-"}
                      />
                    </Flex>
                    {dataDetail?.needReview && (
                      <Flex
                        justifyContent={"space-between"}
                        m={"24px 16px"}
                        gap={"27px"}
                      >
                        <InfoItem
                          label="Cần xem xét"
                          value={dataDetail?.reviewReason || "Cần xem xét"}
                        />
                      </Flex>
                    )}
                  </>
                )}
                <Flex
                  justifyContent={"space-between"}
                  m={"24px 16px"}
                  gap={"27px"}
                >
                  <Flex
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                    maxW={"252px"}
                    w={"100%"}
                  >
                    Mã nhân viên:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      {dataDetail?.employeeObject?.code || ""}
                    </Text>
                  </Flex>
                  <Flex
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                    maxW={"252px"}
                    w={"100%"}
                  >
                    Tên nhân viên:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      {dataDetail?.employeeObject?.fullName || ""}
                    </Text>
                  </Flex>
                </Flex>
                <Flex
                  justifyContent={"space-between"}
                  m={"24px 16px"}
                  gap={"27px"}
                >
                  <Flex
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                  >
                    Điểm chấm công:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      {dataDetail?.checkinPlaceObject?.name || ""}
                    </Text>
                  </Flex>
                </Flex>
                <Flex
                  // justifyContent={"space-between"}
                  m={"24px 16px"}
                  gap={"27px"}
                >
                  <Flex
                    flex={1}
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                  >
                    TGCC đúng giờ khối KD:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      { dataDetail?.checkinPlaceObject?.timeForSale || "" }
                    </Text>
                  </Flex>
                  <Flex
                    flex={1}
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                  >
                    TGCC muộn khối KD:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      { dataDetail?.checkinPlaceObject?.lateTimeForSale || "" }
                    </Text>
                  </Flex>
                </Flex>
                <Flex
                  // justifyContent={"space-between"}
                  m={"24px 16px"}
                  gap={"27px"}
                >
                  <Flex
                    flex={1}
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                  >
                    TGCC đúng giờ khối hỗ trợ:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      { dataDetail?.checkinPlaceObject?.timeForSupport || "" }
                    </Text>
                  </Flex>
                  <Flex
                    flex={1}
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                  >
                    TGCC muộn khối hỗ trợ:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      { dataDetail?.checkinPlaceObject?.lateTimeForSupport || "" }
                    </Text>
                  </Flex>
                </Flex>
                <Flex
                  justifyContent={"space-between"}
                  m={"24px 16px"}
                  gap={"27px"}
                >
                  <Flex
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                    maxW={"252px"}
                    w={"100%"}
                  >
                    Lí do:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      {dataDetail?.comment || ""}
                    </Text>
                  </Flex>
                  <Flex
                    flexWrap={"wrap"}
                    display={"inline"}
                    fontSize={"14px"}
                    lineHeight={"17px"}
                    fontWeight={400}
                    color={"var(--color-label-employee)"}
                    maxW={"252px"}
                    w={"100%"}
                  >
                    Ngày công:
                    <Text
                      display={"inline"}
                      ml={"12px"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={500}
                      color={"var(--color-option-employee)"}
                    >
                      {dataDetail?.workingDayRate || '0'}
                    </Text>
                  </Flex>
                </Flex>
              </Box>
              {dataDetail?.checkinImage && (
                <>
                  <Text
                    mt={"20px"}
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Ảnh chấm công
                  </Text>
                  <Box
                    mt={"20px"}
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    borderRadius={"8px"}
                  >
                    <Flex
                      flexWrap={"wrap"}
                      display={"inline"}
                      fontSize={"14px"}
                      lineHeight={"17px"}
                      fontWeight={400}
                      color={"var(--color-label-employee)"}
                      w={"100%"}
                    >
                      <Flex w={"100%"} justifyContent={"center"}>
                        <a
                          href={`${baseURL}/${dataDetail?.checkinImage}`}
                          target="_blank"
                        >
                          <Image
                            mt={"12px"}
                            src={`${baseURL}/${dataDetail?.checkinImage}`}
                            w={"300px"}
                            h={"300px"}
                            borderRadius={"8px"}
                            objectFit={"contain"}
                          />
                        </a>
                      </Flex>
                    </Flex>
                  </Box>
                </>
              )}
              {dataDetail?.checkoutImage && (
                <>
                  <Text
                    mt={"20px"}
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Ảnh chấm ra
                  </Text>
                  <Box
                    mt={"20px"}
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    borderRadius={"8px"}
                  >
                    <Flex w={"100%"} justifyContent={"center"}>
                      <a
                        href={`${baseURL}/${dataDetail?.checkoutImage}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Image
                          mt={"12px"}
                          src={`${baseURL}/${dataDetail?.checkoutImage}`}
                          w={"300px"}
                          h={"300px"}
                          borderRadius={"8px"}
                          objectFit={"contain"}
                        />
                      </a>
                    </Flex>
                  </Box>
                </>
              )}
            </Box>
          </Flex>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default FormDetail;
